import { ApiError } from '../services/apiError';

const MESSAGES = {
  invalidCredentials: {
    en: 'invalid username or password',
    fr: "Nom d'utilisateur ou mot de passe invalide",
  },
  wrongUsername: {
    en: 'wrong username',
    fr: "Nom d'utilisateur incorrect",
  },
  wrongPassword: {
    en: 'wrong password',
    fr: 'Mot de passe incorrect',
  },
  emptyUsername: {
    en: 'Enter the Username',
    fr: "Entrez le nom d'utilisateur",
  },
  emptyPassword: {
    en: 'Enter the Password',
    fr: 'Entrez le mot de passe',
  },
};

const CODES = {
  USER_NOT_FOUND: 'wrongUsername',
  INVALID_PASSWORD: 'wrongPassword',
  WRONG_PASSWORD: 'wrongPassword',
};

const describeValidationError = (error) => {
  const details = [].concat(error.message ?? []);

  if (details.some((detail) => /password should not be empty/i.test(detail))) {
    return 'emptyPassword';
  }

  if (details.some((detail) => /(email|username) should not be empty/i.test(detail))) {
    return 'emptyUsername';
  }

  return null;
};

const pickMessageKey = (failure) => {
  const error = failure instanceof ApiError ? failure.body : failure;

  if (!error || typeof error !== 'object') {
    return 'invalidCredentials';
  }

  if (error.statusCode === 400) {
    return describeValidationError(error) ?? 'invalidCredentials';
  }

  return CODES[error.code] ?? 'invalidCredentials';
};

export const describeLoginError = (error, isEnglish) =>
  MESSAGES[pickMessageKey(error)][isEnglish ? 'en' : 'fr'];

export const describeEmptyField = (field, isEnglish) =>
  MESSAGES[field === 'password' ? 'emptyPassword' : 'emptyUsername'][
    isEnglish ? 'en' : 'fr'
  ];
